import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Pencil, Trash2, MailCheck, MailX, Mail, Send, Loader2 } from "lucide-react";

const statusLabels = { ACTIVE: "Actif", SUSPENDED: "Suspendu", EXPIRED: "Inactif", FORMER: "Inactif" };
const statusColors = { ACTIVE: "bg-green-100 text-green-700", SUSPENDED: "bg-blue-100 text-blue-700", EXPIRED: "bg-red-100 text-red-600", FORMER: "bg-red-100 text-red-600" };

const EmailBadge = ({ status, sentAt }) => {
  if (status === "SENT") return (
    <span className="inline-flex items-center gap-1 crm-badge bg-green-100 text-green-700" data-testid="detail-email-sent">
      <MailCheck size={12} /> Email envoyé
      {sentAt && <span className="text-xs ml-1 opacity-75">({new Date(sentAt).toLocaleDateString("fr-BE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })})</span>}
    </span>
  );
  if (status === "FAILED") return (
    <span className="inline-flex items-center gap-1 crm-badge bg-red-100 text-red-600" data-testid="detail-email-failed">
      <MailX size={12} /> Email non reçu
    </span>
  );
  if (status === "NOT_REQUESTED") return (
    <span className="inline-flex items-center gap-1 crm-badge bg-gray-100 text-gray-500" data-testid="detail-email-not-requested">
      <Mail size={12} /> Email non demandé
    </span>
  );
  return null;
};

export const MemberHeader = ({ member, resending, onBack, onEdit, onMarkFormer, onDelete, onResendEmail }) => (
  <>
    <button onClick={onBack} className="crm-back-btn"><ArrowLeft size={16} /> Retour</button>
    <div className="crm-detail-header">
      <div>
        <h1 className="crm-page-title">{member.last_name} {member.first_name}</h1>
        <div className="flex items-center gap-3 mt-1 flex-wrap">
          <span className={`crm-badge ${statusColors[member.status]}`}>{statusLabels[member.status]}</span>
          <EmailBadge status={member.email_status} sentAt={member.email_sent_at} />
          {member.email && <span className="text-sm text-[#577083]">{member.email}</span>}
          {member.phone && <span className="text-sm text-[#577083]">{member.phone}</span>}
        </div>
        {member.notes && <p className="text-sm text-[#8fa4b5] mt-2">{member.notes}</p>}
      </div>
      <div className="flex gap-2 flex-wrap">
        {member.email && (
          <Button variant="outline" size="sm" onClick={onResendEmail} disabled={resending}
            className="text-blue-600 border-blue-200 hover:bg-blue-50" data-testid="resend-email-btn">
            {resending ? <Loader2 size={14} className="mr-1 animate-spin" /> : <Send size={14} className="mr-1" />}
            {resending ? "Envoi..." : (member.email_status === "SENT" ? "Renvoyer l'email" : "Envoyer l'email")}
          </Button>
        )}
        <Button variant="outline" size="sm" onClick={onEdit}><Pencil size={14} className="mr-1" /> Modifier</Button>
        {member.status !== "FORMER" && (
          <Button variant="outline" size="sm" onClick={onMarkFormer} className="text-orange-500 border-orange-200 hover:bg-orange-50">Marquer ancien</Button>
        )}
        <Button variant="outline" size="sm" onClick={onDelete} className="text-red-500 border-red-200 hover:bg-red-50">
          <Trash2 size={14} className="mr-1" /> Supprimer
        </Button>
      </div>
    </div>
  </>
);
